import {FC} from 'react'
import {useListView} from '../../core/ListViewProvider'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {RolesListFilter} from './RolesListFilter'

const RolesListToolbar: FC = () => {
  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <RolesListFilter />
    </div>
  )
}

export {RolesListToolbar} 